// extracted by mini-css-extract-plugin
export default {"card":"cardStyle_card__Q3j5P"};